// extracted by mini-css-extract-plugin
export default {"item":"activityItem_item__pgpoT","header":"activityItem_header__h8O8w","dateTime":"activityItem_dateTime__mHSeW","body":"activityItem_body__EoI4p"};